<rt-dialog-header [heading]="'rti.hotelprofessionals.name' | translate">
  {{ 'rti.hotelprofessionals.create_posting.modal.subtitle' | translate }}
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rti-hotelprofessionals-posting-form
    [postingForm]="postingForm"
    [errorFields]="state.errorFields"
  ></rti-hotelprofessionals-posting-form>
  <rti-error-messages-wrapper [errors]="state.errors"> </rti-error-messages-wrapper>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button class="optional" variant="plain" (click)="remove()">
    {{ 'rti.job_boards.edit_posting.remove' | translate }}
  </rt-button>

  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button variant="primary" [disabled]="!formValid" [loading]="state.saving" (click)="save()">
    {{ 'rti.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
